module.exports = __webpack_public_path__ + "img/IMG_9543_L_WoodMatted.ed97d0ef.jpg";